<script>
  import Button from '@ui/pico/button.svelte';
  import { Email } from '@util/auth-firebase';
  import { GoogleAuthProvider, getAuth, signInWithPopup } from 'firebase/auth';
  import { onMount } from 'svelte';
  import { user } from '../../store';
  import { goto } from '../../util';
  import { pages } from '../../config';
  import FaIcon from '../components/fa-icon.svelte';

  $: form = {};
  onMount(() => {
    if ($user && $user.email) {
      return goto(pages.dashboard.url);
    }
  });

  async function authenticate() {
    if (!form.email) return;
    try {
      const auth = getAuth();
      const email = new Email(auth);
      email.responseUrl = window.location.href + '/verify';

      const res = await email.sendLoginLinkToEmail(form.email);
      console.log('authenticate >', res, email.responseUrl);
      goto(pages.entry.waiting.url);
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;

      console.warn('Auth error', { errorCode, errorMessage });
    }
  }
  async function googleLogin() {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    let googleUser;

    // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
    provider.addScope('https://www.googleapis.com/auth/userinfo.email');
    provider.addScope('https://www.googleapis.com/auth/userinfo.profile');

    try {
      googleUser = await signInWithPopup(auth, provider);
      if (googleUser) {
        $user = auth.currentUser;
        window.location = pages.dashboard.url;
      }
    } catch (error) {
      console.warn('failed to link account', error);
    }
  }
  function backToDashboard() {
    goto(pages.dashboard.url);
  }
</script>

<dialog open>
  <article>
    <header>
      <a
        on:click={backToDashboard}
        href="#close"
        aria-label="Close"
        class="close"
      >
        &nbsp;
      </a>
      <span>Enter or Link Your Webforma Account</span>
    </header>
    <form on:submit|preventDefault={authenticate}>
      <hgroup>
        <h2>Quick Login</h2>
        <h4>A code will be sent to you for access</h4>
      </hgroup>

      <input
        autofocus
        bind:value={form.email}
        required
        type="email"
        placeholder="Email only - no password required"
      />
      <Button type="submit" class="contrast" iconLeft="mail" iconSize={32}>
        Send Login Link
      </Button>

      <Button class="google icon-button" on:click={googleLogin}>
        <FaIcon size={22} />
        <div style="border:solid transparent;padding: 0 0.4rem;">Google</div>
      </Button>
      <!-- <Button class="linkedin icon-button" on:click={liLogin}>
        <div style="border:solid transparent;padding: 0 0.4rem;">LinkedIn</div>
        <FaIcon social="linkedin" size={22} />
      </Button>
      <Button class="github icon-button" on:click={githubLogin}>
        <div style="border:solid transparent;padding: 0 0.4rem;">GitHub</div>
        <FaIcon social="github" size={22} />
      </Button>
      <Button class="gitlab icon-button" on:click={gitlabLogin}>
        <div style="border:solid transparent;padding: 0 0.4rem;">Gitlab</div>
        <FaIcon social="gitlab" size={22} />
      </Button> -->
    </form>
  </article>
</dialog>

<style>
  article {
    width: 80vw;
    max-width: 700px;
  }
  article header {
    margin-bottom: 1em;
  }
  header span {
    font-weight: 400;
  }

  :global(button svg) {
    stroke-width: 1.6px;
  }
</style>
